import { useTranslation } from 'react-i18next'

import { Widget } from '../../Widget'
import { useNewsboardPostProfileContext } from '../Newsboard.hooks'

import { NewsboardPostProfileWidgetAudienceContent } from './NewsboardPostProfileWidgetAudienceContent'

function NewsboardPostProfileWidgetAudience() {
  const { t } = useTranslation()

  const { handleUpdateEntity, isInitiated, postData } =
    useNewsboardPostProfileContext()

  const canEditAudience = postData?.permissions?.can_edit_audience

  return (
    <Widget
      headerProps={{
        contentProps: {
          actionsProps: canEditAudience ? undefined : { EditButton: null },
        },
      }}
      isSkeleton={!isInitiated}
      title={t('NewsboardPostProfile.AudienceWidgetTitleKey')}
    >
      <NewsboardPostProfileWidgetAudienceContent
        postData={postData}
        onSubmit={handleUpdateEntity}
      />
    </Widget>
  )
}

export default NewsboardPostProfileWidgetAudience
